import React, {createRef, useEffect, useState} from 'react';
import {Grid} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../components/DialogBox';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useDispatch, useSelector} from 'react-redux';
import AddValueForm from './AddValueForm';
import {httpPaginationDelete} from '../../../util/Rest';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {useUpdateEffect} from 'react-use';
import {fetchLookupDetails} from '../../../redux/reducers/LookupMaintenance/AddLookup';
export default function AddValueTable({rowData, LookupMaintenanceAccess}) {
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const [rowEditData, setRowEditData] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editgetData, setEditGetData] = useState(false);
  const [status, setStatus] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [saveData, setSaveData] = useState([]);
  const dispatch = useDispatch();
  const handleLookupClose = () => {
    setOpenPopup(false);
    setIsEditMode(false);
  };
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
  };

  const {lookupDetailsData} = useSelector(({addLookupMaintenance}) => addLookupMaintenance);

  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useUpdateEffect(() => {
    if (status === true) {
      dispatch(fetchLookupDetails(deleteData?.typeCode));
      setStatus(false);
    }
  }, [status]);
  const handleConfirmDelete = () => {
    httpPaginationDelete(`lookup/delete/lookupdetails/${deleteData?.id}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      title: 'Code',
      field: 'valueCode',
    },
    {
      title: 'Value',
      field: 'value',
    },
    // {
    //   title: "From",
    //   field: "effectiveFrom",
    //   render: (rowData) => {
    //     return rowData?.effectiveFrom ? moment(rowData?.effectiveFrom).format("MM/DD/YYYY") : "";
    //   },
    // },
    // {
    //   title: "To",
    //   field: "effectiveTo",
    //   render: (rowData) => {
    //     return rowData?.effectiveTo ? moment(rowData?.effectiveTo).format("MM/DD/YYYY") : "";
    //   },
    // },
  ];
  const tableRef = createRef();

  useEffect(() => {
    if (lookupDetailsData?.length > 0) {
      const data = lookupDetailsData?.map((i) => {
        return {
          ...i,
          effectiveFrom: i?.effectiveFrom,
          effectiveTo: i?.effectiveTo,
          valueCode: i?.valueCode,
          value: i?.value,
        };
      });
      setSaveData(data);
    }
  }, [lookupDetailsData]);
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title={'Delete Code'}
        value={`Are you sure you want to delete the ${deleteData?.valueCode} Code?`}
        handleSubmit={handleConfirmDelete}
      />
      <DialogBox
        open={openPopup || isEditMode}
        dialogClose={handleLookupClose}
        title={isEditMode ? 'Edit Value' : 'Add a New Value'}
        maxWidth="md"
        hideFooter={true}
      >
        <AddValueForm
          handleLookupClose={handleLookupClose}
          rowEditData={rowEditData}
          isEditMode={isEditMode}
          editgetData={editgetData}
          rowData={rowData}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={saveData}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              paging: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                disabled: !LookupMaintenanceAccess?.edit,
                onClick: (event, rowData) => {
                  setRowEditData(rowData);
                  handleEditRow(rowData);
                  setEditGetData(true);
                },
              },
              {
                icon: () => (
                  <span>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={!LookupMaintenanceAccess?.edit}
                      onClick={() => {
                        setOpenPopup(true);
                        setRowEditData({});
                      }}
                    >
                      <AddIcon /> Add a new Value
                    </Button>
                  </span>
                ),
                disabled: !LookupMaintenanceAccess?.edit,
                isFreeAction: true,
                onClick: () => {},
              },

              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  disabled: !LookupMaintenanceAccess?.edit,
                  tooltip: 'Delete',
                  onClick: () => {
                    setIsDelete(true);
                    setDeleteData(rowData);
                  },
                };
              },
            ]}
          />
        </div>
      </Grid>
      {/* {isLoading && <PageLoader />} */}
      {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
      {tstmsg && <SuccessSnackbar successMsg={tstmsg} />}
    </>
  );
}
